import { render, staticRenderFns } from "./JudgeDetails.vue?vue&type=template&id=2054889e"
import script from "./JudgeDetails.vue?vue&type=script&lang=ts"
export * from "./JudgeDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports